import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls';
import WebRenderer from '@/components/Fitstation3DScan/WebRenderer';
import ShaderData from '@/components/Fitstation3DScan/ShaderData';

export default abstract class WebRendererSetup {
	protected webRenderer: WebRenderer;
	protected shaderData: ShaderData = new ShaderData();

	constructor(webRenderer: WebRenderer) {
		this.webRenderer = webRenderer;
	}

	public abstract getControls(): OrbitControls;

	public abstract onObjectsLoaded(index: number, group);

	public abstract sceneSetup();

	public abstract render(urls: string[], isObj: boolean, canvasContainer: HTMLElement, details?: any);
}
